/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { IAboutDialogFacade } from '../../../../../data-access/src/lib/domain/facades-models/about-dialog-facade-interface';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { GlobalConstants } from '../../constants/global-constants';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Facade for the About Dialog feature.
 */
export class AboutDialogFacade implements IAboutDialogFacade {
  constructor(public messageHandler: DotNetRequestMessageService) {}

  /**
   * Opens the specified URL.
   *
   * @param url - The URL to open.
   */
  public openUrl(url: string): Observable<any> {
    return from(this.messageHandler.sendRequestAsync(GlobalConstants.OpenUrl, [url]));
  }

  /**
   * Closes the window.
   */
  public closeWindow(): void {
    this.messageHandler.sendRequestAsync(GlobalConstants.OnCloseWindow);
  }

  /**
   * Retrieves user data based on the provided request name.
   *
   * @param nameOfRequest - The name of the request.
   * @returns An observable that emits the user data.
   */
  public getUserData(nameOfRequest: string): Observable<any> {
    return from<Promise<any>>(this.messageHandler.sendRequestAsync(nameOfRequest));
  }
}
